import React from 'react';
import cx from 'classnames';

import { renderTextOption as defaultRenderTextOption } from 'utils/renderTextOptionsAutocomplete';
import AutoComplete from 'components/AppointmentInfoCard/Service/AutoComplete';
import IconTooltip from 'components/IconTooltip/IconTooltip';
import { ReactComponent as InfoIcon } from 'assets/icons/info.svg';
import { ReactComponent as WarningOutlineIcon } from 'assets/icons/warning-outline.svg';
import { formatFullPhoneNumber } from 'utils/formatPhoneNumber';
import { IClinicData } from 'redux/clinicDetailsSlice';
import css from './ReasonDropdownSection.module.scss';

interface Props {
  isOpen: boolean;
  options: { id: string; title: string; slug: string }[];
  optionValue: { id: string; title: string; slug: string } | null;
  onChangeIsOpen: (isOpen: boolean) => void;
  onChangeServiceOption: (option: {
    id: string;
    title: string;
    duration: number;
    slug: string;
  }) => void;
  isSingular?: boolean;
  isShownTitle?: boolean;
  placeholder?: string;
  renderTextOption?: any;
  getOptionDisabled?: any;
  groupBy?: any;
  clinicData: IClinicData;
  isSelectedServiceDisabled: boolean;
  isReasonDropdown?: boolean;
  isPractitionerDropdown?: boolean;
  isForceFullWidth?: boolean;
  isPopperFullWidth?: boolean;
}

const buildUnavailableServicesMessage = (clinicData: IClinicData) =>
  `Before booking the following services, ${clinicData.name} requires additional action. Consider other services or contact ${clinicData.name} at ${formatFullPhoneNumber(clinicData.phone)} or ${clinicData.email} for unavailable ones.`;

const ReasonDropdownSection: React.FC<Props> = ({
  isOpen,
  options,
  optionValue,
  onChangeIsOpen,
  onChangeServiceOption,
  isSingular = false,
  isShownTitle = true,
  placeholder,
  renderTextOption,
  getOptionDisabled,
  groupBy,
  clinicData,
  isSelectedServiceDisabled,
  isPractitionerDropdown = false,
  isReasonDropdown = false,
  isForceFullWidth = false,
  isPopperFullWidth = false,
}) => {
  const renderGroup = (params: any) => {
    return (
      <div key={params.key}>
        {params.group === false && (
          <div className={css['unavailable-service']}>
            <span>UNAVAILABLE SERVICES</span>
            <IconTooltip
              IconComponent={InfoIcon}
              id="unavailable-service"
              content={buildUnavailableServicesMessage(clinicData)}
            />
          </div>
        )}
        <div>{params.children}</div>
      </div>
    );
  };

  const containerStyle = cx({
    [css['root']]: true,
    [css['warning-root']]: isSelectedServiceDisabled,
  });

  return (
    <div className={containerStyle}>
      {isShownTitle && <h4 className={css['title']}>Reason</h4>}
      <AutoComplete
        isOpen={isOpen}
        options={options}
        optionValue={optionValue}
        onChangeIsOpen={onChangeIsOpen}
        renderOption={renderTextOption || defaultRenderTextOption}
        onChangeServiceOption={onChangeServiceOption}
        height="2.1rem"
        isSingular={isSingular}
        placeholder={optionValue ? optionValue.title : placeholder}
        getOptionDisabled={getOptionDisabled}
        groupBy={groupBy}
        renderGroup={renderGroup}
        isPractitionerDropdown={isPractitionerDropdown}
        isReasonDropdown={isReasonDropdown}
        isForceFullWidth={isForceFullWidth}
        isPopperFullWidth={isPopperFullWidth}
      />
      {isSelectedServiceDisabled && (
        <div className={css.warning}>
          <IconTooltip
            IconComponent={WarningOutlineIcon}
            id="unavailable-service"
            content={buildUnavailableServicesMessage(clinicData)}
          />
        </div>
      )}
    </div>
  );
};

export default ReasonDropdownSection;
